import React from 'react'
import PropTypes from 'prop-types'
import NProgress from 'nprogress'
import { Router } from 'tools/routes'
import PageProgressStyle from './PageProgress.style'

NProgress.configure({ showSpinner: false })

const PageProgress = React.memo(({ color }) => {
  const timeoutRef = React.useRef()

  React.useEffect(() => {
    const onRouteChangeStart = () => {
      NProgress.start()
    }

    const onRouteChangeComplete = () => {
      timeoutRef.current && clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        NProgress.done(true)
      }, 700)
    }

    const unsubscribeRouteChangeStart = Router.subscribe(Router.events.routeChangeStart, onRouteChangeStart)
    const unsubscribeRouteChangeComplete = Router.subscribe(Router.events.routeChangeComplete, onRouteChangeComplete)

    return () => {
      unsubscribeRouteChangeStart()
      unsubscribeRouteChangeComplete()
    }
  }, [])

  return <PageProgressStyle color={color} />
})

PageProgress.propTypes = {
  color: PropTypes.string
}

export default PageProgress
